



































































































































import { Prop, Component, Vue } from "vue-property-decorator";
import { WorkData } from "../types/models";

@Component
export default class WorkInfo extends Vue {
  @Prop({ required: true, type: Object })
  workData!: WorkData;
  @Prop({ required: true, type: Boolean })
  showWork!: boolean;

  public closeWorkInfo(): void {
    this.$emit("close");
  }
}
